import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2025 Andrii Nastych – Portfolio BTS SIO SISR</p>
      <p style={{ fontSize: '0.7rem' }}>Cybersécurité • Infrastructure • Réseaux</p>
    </footer>
  );
};

export default Footer;